import React, { useEffect, useState, useCallback } from 'react';
import { Box } from '@mui/material';
import { toast } from 'react-toastify'; // <-- import toast
import 'react-toastify/dist/ReactToastify.css';
import DashboardLayout from './DashboardLayout';
import CampaignsManagement from './Campaigns/CampaignsManagement';
import baseURL from '../../user/config';
import PageLoader from '../../../Reusable/PageLoader';

const Dashboard = () => {
    const [campaigns, setCampaigns] = useState([]);
    const [loading, setLoading] = useState(true);

    // Data-fetching function
    const fetchCampaigns = useCallback(async () => {
        setLoading(true);
        try {
             // await new Promise(resolve => setTimeout(resolve, 4000));

            const response = await fetch(`${baseURL}/org/orgcampaigns`, {
                method: 'GET',
                credentials: 'include',
            });
            if (!response.ok) {
                throw new Error('Failed to fetch campaigns.');
            }
            const data = await response.json();
            setCampaigns(data.campaigns);
        } catch (err) {
            toast.error(`Error fetching campaigns: ${err.message}`); // <-- toast for errors
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchCampaigns();
    }, [fetchCampaigns]);

    return (
        <DashboardLayout>
            {loading && <PageLoader />} 

            {!loading && (
                <Box sx={{ p: 1 }}>
                    <CampaignsManagement campaigns={campaigns} refetchCampaigns={fetchCampaigns} />
                </Box>
            )}
        </DashboardLayout>
    );
};

export default Dashboard;
